/*
 * lostEproDevicePopupComponent
 * */

import templateUrl from './lostEproDevicePopup.html';
import controller from './lostEproDevicePopup.controller';
import './lostEproDevicePopup.scss';

const lostEproDevicePopupComponent = {
	bindings: {
		componentReady: '&'
	},
	templateUrl,
	controller
};

export default lostEproDevicePopupComponent;
